import { render, staticRenderFns } from "./EventNews.vue?vue&type=template&id=fbf19cbc"
import script from "./EventNews.vue?vue&type=script&lang=js"
export * from "./EventNews.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports